import { Stack } from "@mui/material";
import { LoginViewModel } from "./LoginViewModel";
import { LOGIN_PAGE_BACKGROUND_IMAGE } from "../../../data/constant/Constants";
import { CustomImageView } from "../../component/CustomImageView";
import LoginForm from "./LoginForm";
import useWindowDimensions from "../../../core/utils/UseWindowDimensions";
import { provideLoginUseCase } from "../../di/UseCasesModule";
import { useEffect } from "react";

export default function LoginView() {
  const { login } = LoginViewModel(provideLoginUseCase());

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  return (
    <Stack position={"relative"}>
      <CustomImageView
        width={"100vw"}
        height={"100vh"}
        src={LOGIN_PAGE_BACKGROUND_IMAGE}
        props={{}}
      />
      <Stack
        position={"absolute"}
        zIndex={1}
        alignItems={"center"}
        width={"100vw"}
        height={"100%"}
        justifyContent={"center"}
      >
        <LoginForm onSubmit={login} />
      </Stack>
    </Stack>
  );
}
